import AdImg from "../../assets/img.jpg";

export const dummyData = [
  {
    id: 1,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "sp",
    stats: {
      val1: "ip:3.1 | pc:34",
      val2: "k:4 | w:3",
    },
    points: 6,
    status: "batting",
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 2,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "if1",
    stats: {
      val1: ".278 | 1/4",
      val2: "rbi:1 | r:0",
    },
    points: 6,
    status: "on field",
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 3,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "if2",
    stats: {
      val1: ".230 | 1/4",
      val2: "rbi:3 | r:1",
    },
    points: 6,
    status: "on deck",
    isHomeRun: true,
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
      throwingPlayer: {
        playerName: "J. Smith",
        stats: "era: 3.23",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 4,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "of1",
    stats: {
      val1: ".308 | 1/4",
      val2: "rbi:1 | r:0",
    },
    points: 6,
    status: "pitching",
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
      throwingPlayer: {
        playerName: "J. Smith",
        stats: "era: 3.23",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 5,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "of2",
    isStarPlayer: true,
    stats: {
      val1: ".278 | 1/4",
      val2: "rbi:1 | r:0",
    },
    points: 6,
    status: "on deck",
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
      throwingPlayer: {
        playerName: "J. Smith",
        stats: "era: 3.23",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 6,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "dh",
    stats: {
      val1: ".230 | 1/4",
      val2: "rbi:3 | r:1",
    },
    points: 6,
    status: "hitting",
    boost: {
      boost: "1.5x",
    },
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
      throwingPlayer: {
        playerName: "J. Smith",
        stats: "era:3.23",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 7,
    playerName: "Aaron Rodgers",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "rp",
    isStarPlayer: true,
    stats: {
      val1: "ip:3.1 | pc:34",
      val2: "k:4 | w:3",
    },
    points: 6,
    status: "dugout",
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
  {
    id: 8,
    name: "Toronto Blue Jays",
    range: "(45-42)",
    homeTeam: "Toronto Mapple Leafs 10",
    awayTeam: "Detroit Tigers 2",
    time: "01:10 PM",
    date: "2020-09-28",
    stadium: "Empower Field",
    type: "d",
    team: "d",
    stats: {
      val1: "avg runs against: 4.3",
    },
    points: -6,
    status: "pitching",
    playerStats: {
      battingPlayer: {
        playerName: "J. Rogers",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
      throwingPlayer: {
        playerName: "J. Smith",
        stats: ".280 | 1/3 | s:0 | b:3",
      },
    },
    pointsSummary: [
      { status: "p1: 19:59", type: "hr", power: "2x", pts: 4 },
      { status: "p2: 13:45", type: "triple", power: "", pts: 2 },
      { status: "p3: 00:01", type: "single", power: "3x", pts: 0 },
      { status: "ot: 04:58", type: "double", power: "1x", pts: 1 },
      { status: "p1: 19:59", type: "walk", power: "4x", pts: 9 },
    ],
    totalPts: 27,
  },
];
